import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { StatCard, MonthlyRegistration, VendorCategory, ActivityItem, UserProfile } from '../../models/dashboard.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  getStatCards(): Observable<StatCard[]> {
    const stats: StatCard[] = [
      {
        title: 'Revenue Collected',
        value: '₦380,750,850',
        change: '+26.4%',
        changeType: 'positive',
        subtitle: 'vs last month',
        icon: 'trending_up'
      },
      {
        title: 'Total Vendors',
        value: '165',
        change: '+12',
        changeType: 'positive',
        subtitle: 'This week',
        icon: 'people'
      },
      {
        title: 'Pending Approvals',
        value: '2',
        change: 'Requires action',
        changeType: 'warning',
        subtitle: '',
        icon: 'pending_actions'
      }
    ];
    return of(stats).pipe(delay(300));
  }

  getMonthlyRegistrations(): Observable<MonthlyRegistration[]> {
    const data: MonthlyRegistration[] = [
      { month: 'Jan', count: 14 },
      { month: 'Feb', count: 19 },
      { month: 'Mar', count: 28 },
      { month: 'Apr', count: 8 },
      { month: 'May', count: 14 },
      { month: 'Jun', count: 26 },
      { month: 'Jul', count: 32 }
    ];
    return of(data).pipe(delay(400));
  }

  getVendorCategories(): Observable<VendorCategory[]> {
    const categories: VendorCategory[] = [
      { name: 'Category A', count: 35, color: '#10B981' },
      { name: 'Category B', count: 45, color: '#F59E0B' },
      { name: 'Category C', count: 15, color: '#3B82F6' },
      { name: 'Category D', count: 5, color: '#3B82A0' }
    ];
    return of(categories).pipe(delay(400));
  }

  getRecentActivities(): Observable<ActivityItem[]> {
    const activities: ActivityItem[] = [
      {
        id: 1,
        user: 'Ngozi M.',
        action: 'created',
        target: 'Beta Services Nigeria Ltd',
        date: '20 Mar',
        time: '11:15',
        actionType: 'created'
      },
      {
        id: 2,
        user: 'Dr. Adeyemi',
        action: 'approved',
        target: 'Alpha Engineering Ltd',
        date: '16 Jan',
        time: '14:20',
        actionType: 'approved'
      },
      {
        id: 3,
        user: 'Chijioke O.',
        action: 'created',
        target: 'Alpha Engineering Ltd',
        date: '15 Jan',
        time: '09:30',
        actionType: 'created'
      },
      {
        id: 4,
        user: 'Ngozi M.',
        action: 'created',
        target: 'Beta Services Nigeria Ltd',
        date: '8 Mar',
        time: '11:15',
        actionType: 'created'
      }
    ];
    return of(activities).pipe(delay(350));
  }

  getUserProfile(): Observable<UserProfile> {
    const user: UserProfile = {
      name: 'Chijioke Okonkwo',
      role: 'MDA Officer',
      avatar: 'CO'
    };
    return of(user).pipe(delay(200));
  }
}
